import { ThunkAction } from 'redux-thunk';
import { api2 } from '../apis';
import {
  SUBSCRIPTION_LOADING,
  SUBSCRIPTION_LOADED,
  SUBSCRIPTION_LOADING_FAILED,
  SUBSCRIPTION_PAYMENT_PROCESSING,
  SUBSCRIPTION_PAYMENT_COMPLETE,
  SUBSCRIPTION_PAYMENT_FAILED,
  SUBSCRIPTION_RESET_MESSAGE
} from 'store/types/subscription.type';

import { State } from 'store/reducers/chat.reducer';

const subscriptionLoading = () => ({ type: SUBSCRIPTION_LOADING });
const subscriptionLoaded = (subscription: any) => ({ type: SUBSCRIPTION_LOADED, payload: subscription });
const subscriptionLoadingFailed = (error: string) => ({ type: SUBSCRIPTION_LOADING_FAILED, error });
const subscriptionPaymentProcessing = () => ({ type: SUBSCRIPTION_PAYMENT_PROCESSING });
const subscriptionPaymentComplete = (message: string) => ({ type: SUBSCRIPTION_PAYMENT_COMPLETE, payload: message });
const subscriptionPaymentFailed = (error: string) => ({ type: SUBSCRIPTION_PAYMENT_FAILED, error });
export const subscriptionMessageReset = () => ({ type: SUBSCRIPTION_RESET_MESSAGE });

export type Actions =
  | ReturnType<typeof subscriptionLoading>
  | ReturnType<typeof subscriptionLoaded>
  | ReturnType<typeof subscriptionLoadingFailed>
  | ReturnType<typeof subscriptionPaymentProcessing>
  | ReturnType<typeof subscriptionPaymentComplete>
  | ReturnType<typeof subscriptionPaymentFailed>
  | ReturnType<typeof subscriptionMessageReset>

type ThunkResult<R> = ThunkAction<R, State, undefined, Actions>;

export const loadSubscription = (callback?: () => void): ThunkResult<void> => dispatch => {
  dispatch(subscriptionLoading())
  api2
    .get('/api/v2/patient/storages')(dispatch)
    .then(res => {
      dispatch(subscriptionLoaded(res))
      callback && callback()
    })
    .catch(err => dispatch(subscriptionLoadingFailed(err.message)));
};


export type SubscribeStoragePayload = {
    initials: string,
    card_id: string,
    update_card?: boolean,
    name?: string
}
export const subscribeStorage = (data: SubscribeStoragePayload, callback?: () => void): ThunkResult<void> => dispatch => {
    dispatch(subscriptionPaymentProcessing())
    api2
    .post('/api/v2/patient/storages/subscribe', data)(dispatch)
    .then(res => {
      dispatch(subscriptionPaymentComplete(data.update_card ? 'Updated payment method successfully!' : 'You are now subscribed!'))
      dispatch(loadSubscription(callback))
    })
    .catch(err => dispatch(subscriptionPaymentFailed(err.message)));
}

export const unsubscribeStorage = (callback?: () => void): ThunkResult<void> => dispatch => {
    dispatch(subscriptionPaymentProcessing())
    api2
    .post('/api/v2/patient/storages/unsubscribe', {})(dispatch)
    .then(res => {
      dispatch(loadSubscription())
      dispatch(subscriptionPaymentComplete('You are now unsubscribed!'))
      callback && callback()
    })
    .catch(err => {
        dispatch(subscriptionPaymentFailed(err.message))
    });
}
